// packages/storefront/src/components/general/originNotAllowedKeys.ts
//
// The texts `OriginNotAllowedAlert` renders, its `CurrentUrlCopyBox` included. A widget that renders
// `WidgetErrorAlert` spreads this table into its fetch list (the chat, the reviews widget), and the alert is shown
// translated only when every one of them arrived.

import type { CommonKey, CommonT } from '@tourtask/i18n/keys';
import type { ResultError } from '@tourtask/types/result';

export const ORIGIN_NOT_ALLOWED_KEYS = [
	'This_website_is_not_registered_with_TourTask',
	'ORIGIN_NOT_ALLOWED_INFO',
	'Copy_to_clipboard',
	'Copied_to_clipboard',
] as const satisfies readonly CommonKey[];

/**
 * Whether a widget shows `error` as the translated page-not-registered notice: the API refused the page
 * (`CORS.ORIGIN_NOT_ALLOWED`) and every one of its texts arrived. Otherwise it says the API's own words
 * (`WidgetErrorAlert`, and the terms widget's own copy of it).
 */
export function showsOriginNotAllowedNotice(error: ResultError, getStr: Pick<CommonT, 'has'>): boolean {
	return error.code === 'CORS.ORIGIN_NOT_ALLOWED' && ORIGIN_NOT_ALLOWED_KEYS.every((key) => getStr.has(key));
}
